import { request } from '../utils/request';

/**
 * Convert a Date or date string to ISO-8601 OffsetDateTime string with UTC offset.
 * Server expects OffsetDateTime (e.g. "2026-03-23T00:00:00Z").
 *
 * @param {Date|string} date - JS Date or YYYY-MM-DD string
 * @returns {string} ISO-8601 datetime string with Z suffix
 */
function toOffsetDateTimeParam(date) {
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return `${date}T00:00:00Z`;
  }
  if (date instanceof Date) {
    return date.toISOString();
  }
  return String(date);
}

/**
 * Get events for a specific date.
 *
 * @param {Date|string} date - date to query (Date or YYYY-MM-DD string)
 * @param {string} [lang] - language code, e.g. 'zh' or 'en'
 * @returns {Promise<Array>} list of events
 */
export function getEventsByDate(date, lang) {
  const param = toOffsetDateTimeParam(date);
  const langParam = lang ? `&lang=${encodeURIComponent(lang)}` : '';
  return request(`/api/events/by-date?date=${encodeURIComponent(param)}${langParam}`);
}

/**
 * Get events within a date range.
 *
 * @param {Date|string} startDate - range start (Date or YYYY-MM-DD string)
 * @param {Date|string} endDate - range end (Date or YYYY-MM-DD string)
 * @param {string} [lang] - language code, e.g. 'zh' or 'en'
 * @returns {Promise<Array>} list of events
 */
export function getEventsByDateRange(startDate, endDate, lang) {
  const start = toOffsetDateTimeParam(startDate);
  const end = toOffsetDateTimeParam(endDate);
  const langParam = lang ? `&lang=${encodeURIComponent(lang)}` : '';
  return request(
    `/api/events/by-date-range?startDate=${encodeURIComponent(start)}&endDate=${encodeURIComponent(end)}${langParam}`
  );
}
